import React from "react";
import {
  Box,
  Text,
  VStack,
  HStack,
  Image,
  Button,
  Flex,
} from "@chakra-ui/react";
import M17 from "../../assets/m17.png";
import A55 from "../../assets/a55.png";
import Pro17 from "../../assets/17pro.png";



export default function TournamentDetails() {
  return (
    <Box
      minH="100vh"
      px={{ base: 4, md: 10 }}
      py={12}
      color="white"
      position="relative"
      overflow="hidden"
      bg="radial-gradient(circle at top left, #2a0a3d 0%, #12071f 40%, #070312 80%)"
    >
      {/* Background Glow */}
      <Box
        position="absolute"
        top="50%"
        right="40%"
        w="350px"
        h="360px"
        bg="radial-gradient(circle, #8B5CF6 0%, transparent 70%)"
        filter="blur(120px)"
        zIndex={0}
      />

      <VStack spacing={12} position="relative" zIndex={1}>
        {/* Heading */}
        <VStack spacing={4}>
          <Text
            fontSize={{ base: "35", md: "115.5" }}
            fontWeight="extrabold"
            bgGradient="linear(to-r, #FFFFFF, #BDA8FB)"
            bgClip="text"
            textAlign="center"
          >
            HOLI MANIA RUMMY
          </Text>

          <Text
            letterSpacing="0.6em"
            color="#A855F7"
            fontWeight="bold"
            fontSize={{base:26 ,md:76.3}}
          >
            TOURNAMENT
          </Text>

          {/* Date Badge */}
          <Box
            px={6}
            py={3}
            bg="rgba(255,255,255,0.08)"
            backdropFilter="blur(10px)"
            borderRadius="xl"
            border="1px solid rgba(255,255,255,0.15)"
            textAlign="center"
            position={"relative"}
          >
            <Text fontSize={{base:28, md:64}} fontWeight="bold">
              28<sup>th</sup> FEB to 1<sup>st</sup> MAR
            </Text>
            <Text fontSize={{base:18, md:29}} color="gray.300">
              Enjoy the skill based game, No Real money gaming
            </Text>
          </Box>

           <Box
        position="absolute"
        top="20%"
        right="90%"
        w="350px"
        h="360px"
        bg="radial-gradient(circle, #8B5CF6 0%, transparent 70%)"
        filter="blur(120px)"
        zIndex={0}
      />
       <Box
        position="absolute"
        top="20%"
        right="-15%"
        w="350px"
        h="360px"
        bg="radial-gradient(circle, #8B5CF6 0%, transparent 70%)"
        filter="blur(120px)"
        zIndex={0}
      />
        </VStack>

        {/* Prize Section */}
        <HStack
          spacing={{ base: 6, md: 12 }}
          flexWrap="wrap"
          justify="center"
        >
          {[
            {
              title: "1st PRIZE",
              name: "iPhone 17 pro",
              image: Pro17
            },
            {
              title: "2nd PRIZE",
              name: "Samsung Galaxy A55 5G",
              image: A55
            },
            {
              title: "3rd PRIZE",
              name: "Samsung Galaxy M17 5G",
              image: M17
            },
          ].map((item, index) => (
            <VStack key={index} spacing={4}>
              <Text
                fontWeight="bold"
                bgGradient={"linear(to-r, #D946EF, #8B5CF6)"} bgClip={"text"}
                fontSize="45"
              >
                {item.title}
              </Text>

              <Box
                w={{ base: "100%", md: "280px" }}
                minH="350px"                     // Force equal height
                p={4}
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="space-between"   // Space evenly
                bg="rgba(255,255,255,0.05)"
                borderRadius="2xl"
                border="1px solid rgba(255,255,255,0.15)"
                backdropFilter="blur(12px)"
                transition="0.3s ease"
                _hover={{
                  transform: "translateY(-8px)",
                  boxShadow: "0 0 40px rgba(168,85,247,0.6)",
                }}
              >
                {/* Image */}
                <Image
                  src={item.image}
                  alt="Prize"
                  borderRadius="xl"
                  w="100%"
                  h="220px"              // Fixed image height
                  objectFit="cover"
                  mb={6}
                />

                {/* Text Container (Fixed Height) */}
                <Box minH="70px" display="flex" alignItems="center">
                  <Text
                    textAlign="center"
                    fontWeight="semibold"
                    fontSize="26px"
                    noOfLines={2}         // Max 2 lines always
                  >
                    {item.name}
                  </Text>
                </Box>
              </Box>


            </VStack>
          ))}
        </HStack>

        {/* Terms Section */}
        <VStack spacing={4} maxW="700px" textAlign="center">
          <Text fontSize="xl" fontWeight="bold">
            Terms & Condition
          </Text>

          <Text color="#A78BFA" fontSize={{base:16,md:24}}>
            Join a team where growth, ambition, and community actually mean
            something. Come see what life is like with us—we're always
            looking for experts to help us level up.
          </Text>
        </VStack>

        {/* Register Button */}
        <Button
          size="lg"
          px={10}
          py={6}
          borderRadius="xl"
          bgColor={"#8B5CF6"}

          _hover={{
            opacity: 0.9,

          }}
        >
          Register Now
        </Button>
      </VStack>
    </Box>
  );
}
